var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpSoftwareDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 14.6666L18.3333 19.25L13.75 23.8333",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.834 20.1666H31.1673",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2493 3.66663H2.74935C1.73683 3.66663 0.916016 4.48744 0.916016 5.49996V38.5C0.916016 39.5125 1.73683 40.3333 2.74935 40.3333H41.2493C42.2619 40.3333 43.0827 39.5125 43.0827 38.5V5.49996C43.0827 4.48744 42.2619 3.66663 41.2493 3.66663Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5007 7.33337H5.50065C4.99439 7.33337 4.58398 7.74378 4.58398 8.25004V35.75C4.58398 36.2563 4.99439 36.6667 5.50065 36.6667H38.5007C39.0069 36.6667 39.4173 36.2563 39.4173 35.75V8.25004C39.4173 7.74378 39.0069 7.33337 38.5007 7.33337Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpSoftwareDevelopment);
export default __webpack_public_path__ + "static/media/exp_software_development.866b025686a47415aead9955f303f9d0.svg";
export { ForwardRef as ReactComponent };